import { createFileRoute, redirect } from '@tanstack/react-router'
import { parse } from 'valibot'

import { getDefaultUserMeTenant } from '@/features/auth/models'
import { fetchShipmentCategoryImportJobs } from '@/features/shipment-category-import-jobs/api'
import { USER_TYPE } from '@/libs/api/types'
import {
  selectedDcIdAtom,
  tenantStore
} from '@/routes/_protected/$tenantKey/-states'

import { shipmentCategoryImportJobsSearchSchema } from './-models'

export const Route = createFileRoute(
  '/_protected/$tenantKey/settings/shipment-category-import-jobs/'
)({
  validateSearch: (search) =>
    parse(shipmentCategoryImportJobsSearchSchema, search),
  loaderDeps: ({ search }) => search,
  beforeLoad: ({ search, location }) => {
    const selectedDcId = tenantStore.get(selectedDcIdAtom)
    if (search.dcId != selectedDcId) {
      throw redirect({
        to: location.pathname,
        search: {
          ...search,
          dcId: selectedDcId
        }
      })
    }
  },
  loader: async ({
    abortController,
    params: { tenantKey },
    deps,
    context: { auth }
  }) => {
    if (auth.user.type === USER_TYPE.PARTNER) {
      throw redirect({
        to: `/${getDefaultUserMeTenant(auth.user).key}`
      })
    }
    return {
      shipmentCategoryImportJobs: await fetchShipmentCategoryImportJobs(
        { tenantKey, query: { ...deps, dcId: deps.dcId! } },
        abortController.signal
      )
    }
  }
})
